export const isAggregateProductionRoute = (dept) =>
  !dept || ["production", "all"].includes(String(dept).toLowerCase());

export const appendProductionBoardFilters = (url, {
  instanceUniqueId = "",
  appliedSearchQuery = "",
  selectedDepartment = "",
  department = "",
  appliedAdvancedFilters = {},
  includeMachine = false,
  boardView = true,
} = {}) => {
  const params = new URLSearchParams();
  if (boardView) params.set("view", "board");
  if (instanceUniqueId) params.set("instanceUniqueId", instanceUniqueId);
  if (String(appliedSearchQuery).trim()) {
    params.set("q", String(appliedSearchQuery).trim());
  }
  const serverDepartment = selectedDepartment ||
    (isAggregateProductionRoute(department) ? "" : department);
  if (serverDepartment) params.set("department", serverDepartment);
  if (appliedAdvancedFilters.dateFrom) {
    params.set("dateFrom", `${appliedAdvancedFilters.dateFrom}T00:00:00`);
  }
  if (appliedAdvancedFilters.dateTo) {
    params.set("dateTo", `${appliedAdvancedFilters.dateTo}T23:59:59`);
  }
  if (includeMachine && appliedAdvancedFilters.machine) {
    params.set("machine", appliedAdvancedFilters.machine);
  }
  const query = params.toString();
  return query ? `${url}&${query}` : url;
};
